module.exports = __webpack_public_path__ + "img/search-outline.4fc944f5.svg";